<template>
  <div class="number-input">
    <button
      @click="decrease"
      :class="{ disabled: modelValue <= min || disabledMinus }"
      class="round-button"
    >
      <Icon
        class="round-button__icon"
        name="reduce-l"
      />
    </button>
    <input
      :value="modelValue"
      :disabled="disabledMinus && disabledPlus"
      @blur="onBlur"
      type="number"
    >
    <button
      @click="increase"
      :class="{ disabled: modelValue >= max || disabledPlus }"
      class="round-button"
    >
      <Icon
        class="round-button__icon"
        name="add-l"
      />
    </button>
  </div>
</template>

<script setup>
import { Icon } from '../Icon'

const props = defineProps({
  disabledMinus: {
    type: Boolean,
    default: false
  },
  disabledPlus: {
    type: Boolean,
    default: false
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: Infinity
  },
  step: {
    type: Number,
    default: 1
  }
})

const emit = defineEmits(['minus', 'plus', 'change'])

const modelValue = defineModel({ required: true })

const increase = () => {
  if (props.disabledPlus) return
  modelValue.value = modelValue.value + props.step <= props.max ? modelValue.value + props.step : props.max

  nextTick(() => {
    emit('plus')
    emit('change')
  })
}

const decrease = () => {
  if (props.disabledMinus) return
  modelValue.value = modelValue.value - props.step >= props.min ? modelValue.value - props.step : props.min

  nextTick(() => {
    emit('minus')
    emit('change')
  })
}

const onBlur = (e) => {
  let val = Number(e.target.value)
  if (isNaN(val)) val = props.min
  val = Math.max(Math.min(val, props.max), props.min)
  e.target.value = modelValue.value = val
  /**
   * 防止出现外部再修改 modelValue，但是不 input value 没有变化的问题
   */
  nextTick(() => {
    emit('change')
  })
}
</script>

<style scoped lang="less">
.number-input {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1.5px solid var(--light-split-color);
  border-left: none;
  border-right: none;
  border-radius: 14px;
  background-color: #fff;
}

input {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
  outline: none;
  font-size: 12px;
  color: #232323;
  font-family: mon-500;

  &:disabled {
    background-color: transparent;
    color: #b2b7c2;
  }
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}

.round-button {
  margin: -1px;
  width: 32px;
  height: 32px;
  border: 1.5px solid var(--light-split-color);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;

  &:hover {
    background-color: #052784;

    .round-button__icon {
      color: #fff;
    }
  }

  &.disabled {
    cursor: not-allowed;
    background-color: #ebebeb;

    .round-button__icon {
      color: #B2B7C2;
    }
  }
}
</style>
